import React from "react"
import BaseIcon from "./BaseIcon"

const CloseIcon = ({ color, ...props }) => (
    <BaseIcon
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11.5"
            cy="11.5"
            r="10.25"
            stroke={color ? color : "white"}
            strokeWidth="1.5"
        />
        <path
            d="M7.40938 16.9445C10.2944 13.7201 13.8752 10.1393 17.0826 7.27132L15.8607 6.04944C12.9927 9.25687 9.41191 12.8377 6.1875 15.7227L7.40938 16.9445Z"
            fill={color ? color : "white"}
        />
        <path
            d="M16.6948 16.1822C13.7341 13.0272 10.479 9.14794 7.90148 5.70274L6.57776 6.81348C9.52303 9.95014 12.7781 13.8294 15.3711 17.293L16.6948 16.1822Z"
            fill={color ? color : "white"}
        />
    </BaseIcon>
)

export default CloseIcon
